module.exports = __webpack_public_path__ + "static/media/team-suzie.6d76d46e.jpg";